import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';

// This hook is used to limit the number of products initially shown to a user
// on a product list page. It provides a function which can be called (when the
// user clicks Load More) to increase the number of products that are shown.

// Note: the actual data loading should occur in a separate hook (e.g.
// useProductListingQuery), this hook just limits the number that are shown.

import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';

// Note: a separate totalProductCount argument is critical because the products
// prop may only contain the initial set of products instead of all products.
const useLoadMoreProducts = t0 => {
  const $ = _c(18);
  const {
    products: t1,
    totalProductCount
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const products = t2;
  const [numberOfProductsToShow, setNumberOfProductsToShow] = useState(NUMBER_OF_PRODUCTS_TO_SHOW);
  const [loadMoreClickCount, setLoadMoreClickCount] = useState(0);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setNumberOfProductsToShow(_temp);
      setLoadMoreClickCount(_temp2);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const loadMoreProducts = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setNumberOfProductsToShow(-1);
      setLoadMoreClickCount(-1);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const loadAllProducts = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setNumberOfProductsToShow(NUMBER_OF_PRODUCTS_TO_SHOW);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const resetNumberOfProductsToShow = t5;
  const areAllProductsShown = numberOfProductsToShow === -1;
  let t6;
  if ($[5] !== areAllProductsShown || $[6] !== numberOfProductsToShow || $[7] !== products) {
    t6 = areAllProductsShown ? products : products.slice(0, numberOfProductsToShow);
    $[5] = areAllProductsShown;
    $[6] = numberOfProductsToShow;
    $[7] = products;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const productsToShow = t6;
  let t7;
  if ($[9] !== areAllProductsShown || $[10] !== numberOfProductsToShow || $[11] !== products) {
    t7 = !areAllProductsShown && products.length > numberOfProductsToShow + NUMBER_OF_PRODUCTS_TO_SHOW ? products.slice(numberOfProductsToShow, numberOfProductsToShow + NUMBER_OF_PRODUCTS_TO_SHOW) : [];
    $[9] = areAllProductsShown;
    $[10] = numberOfProductsToShow;
    $[11] = products;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const productsToPreload = t7;
  const t8 = !areAllProductsShown && totalProductCount > numberOfProductsToShow && productsToShow.length > 0;
  let t9;
  if ($[13] !== loadMoreClickCount || $[14] !== productsToPreload || $[15] !== productsToShow || $[16] !== t8) {
    t9 = {
      loadMoreClickCount,
      loadAllProducts,
      loadMoreProducts,
      productsToPreload,
      productsToShow,
      resetNumberOfProductsToShow,
      showLoadMoreButton: t8
    };
    $[13] = loadMoreClickCount;
    $[14] = productsToPreload;
    $[15] = productsToShow;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const productsWithLoadMoreState = t9;
  return productsWithLoadMoreState;
};
export default useLoadMoreProducts;
function _temp(prevNumberOfProductsToShow) {
  return prevNumberOfProductsToShow + NUMBER_OF_PRODUCTS_TO_SHOW;
}
function _temp2(prevCount) {
  return prevCount + 1;
}